<template>
  <div class="visit">
    <div class="my-chard">
      <!-- 顶部区域 -->
      <el-card shadow="never" class="chard-box first">
        <div class="top6 clearfix">
          <div class="fl">
            <img
              src="../../../assets/images/newIcon/accessanalysis_traffic_icon@2x.png"
              alt=""
            />
            <span></span><b style="font-weight: 500">流量总览</b>
          </div>
          <!-- 右侧区域 -->
          <div class="fr">
            <p>
              <img
                src="../../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <el-select
                style="width: 100px"
                v-model="def"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.type"
                  :value="item.type"
                >
                </el-option>
                <el-date-picker
                  v-if="isshow"
                  v-model="value1"
                  class="rqc"
                  ref="int"
                  type="date"
                >
                </el-date-picker>
              </el-select>
            </p>
          </div>
        </div>
        <div class="t1">
          <div
            @click="active = 1"
            :class="{ bgcBlue: active == 1 }"
            class="t1-1"
          >
            <p class="fz16" style="font-weight: 500">全部</p>
            <p class="fz14">
              访客数 <span style="font-weight: bold">300</span>
            </p>
          </div>
          <div
            @click="active = 2"
            :class="{ bgcBlue: active == 2 }"
            class="t1-2"
          >
            <p class="fz16" style="font-weight: 500">小程序</p>
            <p>访客数 <span style="font-weight: bold">300</span></p>
          </div>
          <div
            @click="active = 3"
            :class="{ bgcBlue: active == 3 }"
            class="t1-3"
          >
            <p class="fz16" style="font-weight: 500">APP</p>
            <p class="fz14">
              访客数 <span style="font-weight: bold">300</span>
            </p>
          </div>
        </div>
        <div class="t2">
          <div class="t2-l">
            <div class="t2-l-img">
              <img
                src="../../../assets/images/newIcon/accessanalysis_trafficaccess_icon@2x.png"
                alt=""
              />
              <p style="font-size: 14px">流量访问</p>
            </div>
          </div>
          <div class="t2-r">
            <ul>
              <li>
                <p>
                  访客数
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，访问系统的客户数量"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>199 <span>人</span></p>
                <p>
                  较前一日<span class="red"
                    >5.9% <i class="el-icon-top"></i
                  ></span>
                </p>
              </li>
              <li>
                <p>
                  新访客
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，访问系统的新用户数量"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>199 <span>人</span></p>
                <p>
                  较前一日<span class="gru"
                    >5.9% <i class="el-icon-bottom"></i
                  ></span>
                </p>
              </li>
              <li>
                <p>
                  浏览量
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，启动系统应用的次数总和"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>0<span></span></p>
                <p>
                  较前一日~
                  <!-- <span class="gru">5.9% <i class="el-icon-bottom"></i></span> -->
                </p>
              </li>
              <li>
                <p>
                  平均停留时长
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，系统所有访客统计时长的总和/访客数"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>0<span></span></p>
                <p>
                  较前一日~
                  <!-- <span class="red">5.9% <i class="el-icon-top"></i></span> -->
                </p>
              </li>
              <li>
                <p>
                  人均浏览量
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，系统所有访客的浏览次数/访客数"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>0<span></span></p>
                <p>
                  较前一日~
                  <!-- <span class="red"
                    >5.9% <i class="el-icon-top"></i
                  ></span> -->
                </p>
              </li>
              <li>
                <p>
                  跳失率
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，只访问一个页面就退出的访客数/总访客数"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>0<span></span></p>
                <p>
                  较前一日~
                  <!-- <span class="red"
                    >5.9% <i class="el-icon-top"></i
                  ></span> -->
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="t3">
          <div class="t3-l">
            <div class="t3-l-img">
              <img
                src="../../../assets/images/newIcon/accessanalysis_deal_icon@2x.png"
                alt=""
              />
              <p style="font-size: 14px">成交转化</p>
            </div>
          </div>
          <div class="t3-r">
            <ul>
              <li>
                <p>
                  支付人数
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，支付费用的访客总数。"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>199 <span></span></p>
                <p>
                  较前一日<span class="red"
                    >5.9% <i class="el-icon-top"></i
                  ></span>
                </p>
              </li>
              <li>
                <p>
                  访问-支付转化率
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="统计时间内，访客总数/支付人数"
                    placement="right"
                  >
                    <img
                      src="../../../assets/images/newIcon/tishi_icon.png"
                      alt=""
                    />
                  </el-tooltip>
                </p>
                <p>199 <span></span></p>
                <p>
                  较前一日<span class="gru"
                    >5.9% <i class="el-icon-bottom"></i
                  ></span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </el-card>
      <!-- 图1 -->
      <el-card shadow="never" class="chard-box">
        <ARvisit
          did="d1"
          title="人均启动次数"
          date="2021.06.18 ～ 2021.07.20过去30日的启动次数"
          text="次"
          rt="31,13"
        ></ARvisit>
      </el-card>
      <!-- 图2 -->
      <el-card shadow="never" class="chard-box">
        <ARvisit
          did="d2"
          title="人均使用时长"
          date="2021.06.18 ～ 2021.07.20过去30日的人均使用时长"
          text="秒"
          rt="31,123"
        ></ARvisit>
      </el-card>
      <!-- 图3 -->
      <el-card shadow="never" class="chard-box">
        <!-- 图内顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">新老用户启动次数</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20近30日新用户启动次数</span>
        <!-- 数字日期区域 -->
        <div class="numDate">
          <p class="date" style="margin-bottom: 10px">7-27 (二)</p>
          <div class="num">
            <div class="left">
              <span class="buleBar"></span
              ><span style="font-size: 14px">新客户人均启动次数</span>
              <p
                class="blueColor fz43"
                style="margin-top: 10px; font-weight: bold"
              >
                1.36<span class="fz12">次</span>
              </p>
            </div>
            <div class="right">
              <span class="popBar"></span
              ><span style="font-size: 14px">老客户人均次数</span>
              <p
                class="blueColor fz43"
                style="margin-top: 10px; font-weight: bold"
              >
                1.29<span class="fz12">次</span>
              </p>
            </div>
          </div>
        </div>
        <div id="d3" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图4 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">新老用户使用时长</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20近30日新用户使用时长</span>
        <!-- 数字日期区域 -->
        <div class="numDate">
          <p class="date" style="margin-bottom: 10px">7-27 (二)</p>
          <div class="num">
            <div class="left">
              <span class="buleBar"></span
              ><span style="font-size: 14px">新客户人均使用时长</span>
              <p
                class="blueColor fz43"
                style="margin-top: 10px; font-weight: bold"
              >
                1.36<span class="fz12">秒</span>
              </p>
            </div>
            <div class="right">
              <span class="greBar"></span
              ><span style="font-size: 14px">老客户人均使用时长</span>
              <p
                class="blueColor fz43"
                style="margin-top: 10px; font-weight: bold"
              >
                1.29<span class="fz12">秒</span>
              </p>
            </div>
          </div>
        </div>
        <div id="d4" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图5 -->
      <el-card shadow="never" class="chard-box">
        <ARvisit
          did="d5"
          title="人均浏览深度"
          date="2021-06-28～2021-07-28过去30天的人均浏览深度"
          text="次"
          rt="31,13"
        ></ARvisit>
      </el-card>
      <!-- 图6 -->
      <el-card shadow="never" class="chard-box">
        <ARvisit
          did="d6"
          title="平均浏览深度"
          date="2021-06-28～2021-07-28过去30天的平均浏览深度"
          text="秒"
          rt="31,123"
        ></ARvisit>
      </el-card>
      <!-- 图7 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vip_fangwen_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">访问行为概览</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20过去30日的用户访问情况</span>
        <div id="c7" style="margin-top: 30px"></div>
      </el-card>
      <!-- 图8 -->
      <el-card shadow="never" class="chard-box">
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/accessanalysis_ranklist_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight: 500">页面访问排行榜</b>
        </div>
        <span class="text"
          >2021.06.18 ～ 2021.07.20过去30日的页面访问人数排行榜</span
        >
        <div id="c8" style="margin-top: 30px"></div>
      </el-card>
    </div>
  </div>
</template>

<script>
import ARvisit from "./AARRcom/ARvisit.vue";
import { Chart } from "@antv/g2";
export default {
  components: {
    ARvisit,
  },
  data() {
    return {
      //显示日期组件
      isshow: false,
      value1: null,
      active: 1,
      def: "今日",
      options1: [
        { type: "今日" },
        { type: "近7天" },
        { type: "近30天" },
        { type: "时间筛选" },
      ],
      //图表数据
      data: [
        { data: "6.21", type: "日人均访问次数", val: 120 },
        { data: "6.22", name: "日人均访问次数", val: 750 },
        { data: "6.23", name: "日人均访问次数", val: 270 },
        { data: "6.24", name: "日人均访问次数", val: 280 },
        { data: "6.25", name: "日人均访问次数", val: 850 },
        { data: "6.26", name: "日人均访问次数", val: 150 },
        { data: "6.27", name: "日人均访问次数", val: 700 },
        { data: "6.21", name: "人均访问时长(分钟)", val: 700 },
        { data: "6.22", name: "人均访问时长(分钟)", val: 150 },
        { data: "6.23", name: "人均访问时长(分钟)", val: 850 },
        { data: "6.24", name: "人均访问时长(分钟)", val: 280 },
        { data: "6.25", name: "人均访问时长(分钟)", val: 270 },
        { data: "6.26", name: "人均访问时长(分钟)", val: 750 },
        { data: "6.27", name: "人均访问时长(分钟)", val: 120 },
        { data: "6.21", name: "人均访问页面数", val: Math.random() * 1000 },
        { data: "6.22", name: "人均访问页面数", val: Math.random() * 1000 },
        { data: "6.23", name: "人均访问页面数", val: Math.random() * 1000 },
        { data: "6.24", name: "人均访问页面数", val: Math.random() * 1000 },
        { data: "6.25", name: "人均访问页面数", val: Math.random() * 1000 },
        { data: "6.26", name: "人均访问页面数", val: Math.random() * 1000 },
        { data: "6.27", name: "人均访问页面数", val: Math.random() * 1000 },
        { data: "6.21", name: "月人均访问频次", val: Math.random() * 1000 },
        { data: "6.22", name: "月人均访问频次", val: Math.random() * 1000 },
        { data: "6.23", name: "月人均访问频次", val: Math.random() * 1000 },
        { data: "6.24", name: "月人均访问频次", val: Math.random() * 1000 },
        { data: "6.25", name: "月人均访问频次", val: Math.random() * 1000 },
        { data: "6.26", name: "月人均访问频次", val: Math.random() * 1000 },
        { data: "6.27", name: "月人均访问频次", val: Math.random() * 1000 },
      ],
    };
  },
  watch: {
    value1() {
      if (this.value1) {
        this.isshow = false;
      }
    },
    def() {
      if (this.def == "时间筛选") {
        this.isshow = true;
        this.$nextTick(() => {
          this.$refs.int.$children[0].focus();
        });
      } else {
        this.isshow = false;
      }
    },
  },
  mounted() {
    //图1
    this.init("c7", this.data, 350);
    this.init2();
    //图34
    this.init3("d3");
    this.init3("d4");
  },
  methods: {
    //折线图
    init(id, data, height) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        height: height || 300,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });
      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showMarkers: false,
      });
      chart.axis("val", {
        label: {
          formatter: (val) => {
            return val;
          },
        },
      });

      chart.line().position("data*val").shape("smooth").color("name");

      // chart.point().position("data*val").shape("circle");

      chart.render();
    },
    //横条形图
    init2() {
      const data = [
        { country: "页面五", population: 232 },
        { country: "页面四", population: 399 },
        { country: "页面三", population: 566 },
        { country: "页面二", population: 657 },
        { country: "页面一", population: 777 },
      ];

      const chart = new Chart({
        container: "c8",
        autoFit: true,
        height: 350,
      });

      chart.axis("country", {
        tickLine: null, // 不显示刻度线
      });

      chart.data(data);
      chart.scale("population", { nice: true });
      // chart.color("population",["#f7b500"])
      chart.coordinate().transpose();
      chart.tooltip({
        showMarkers: false,
      });
      chart.interaction("active-region");
      chart
        .interval()
        .position("country*population")
        .color("country", [
          "#A1BAE6",
          "#CA97F7 ",
          "#5AD8A6 ",
          "#F7B500",
          "#5B8FF9",
        ])
        .label("population", {
          style: {
            fill: "#8d8d8d", //字体颜色
          },
          offset: 4, //文字离柱体的距离
        });
      chart.legend(false);
      chart.render();
    },
    //柱线图
    init3(id) {
      const data1 = [
        { type: "新客户人均启动次数", name: "6.28", value: 50 },
        { type: "新客户人均启动次数", name: "6.30", value: 900 },
        { type: "新客户人均启动次数", name: "7.2", value: 400 },
        { type: "新客户人均启动次数", name: "7.4", value: 550 },
        { type: "新客户人均启动次数", name: "7.6", value: 350 },
        { type: "新客户人均启动次数", name: "7.8", value: 150 },
        { type: "新客户人均启动次数", name: "7.10", value: 750 },
        { type: "新客户人均启动次数", name: "7.12", value: 800 },
        { type: "新客户人均启动次数", name: "7.14", value: 450 },
        { type: "新客户人均启动次数", name: "7.16", value: 600 },
        { type: "新客户人均启动次数", name: "7.18", value: 750 },
        { type: "新客户人均启动次数", name: "7.20", value: 1000 },
        { type: "新客户人均启动次数", name: "7.22", value: 750 },

        { type: "老客户人均启动次数", name: "6.28", value: 800 },
        { type: "老客户人均启动次数", name: "6.30", value: 900 },
        { type: "老客户人均启动次数", name: "7.2", value: 400 },
        { type: "老客户人均启动次数", name: "7.4", value: 550 },
        { type: "老客户人均启动次数", name: "7.6", value: 50 },
        { type: "老客户人均启动次数", name: "7.8", value: 750 },
        { type: "老客户人均启动次数", name: "7.10", value: 750 },
        { type: "老客户人均启动次数", name: "7.12", value: 800 },
        { type: "老客户人均启动次数", name: "7.14", value: 450 },
        { type: "老客户人均启动次数", name: "7.16", value: 80 },
        { type: "老客户人均启动次数", name: "7.18", value: 750 },
        { type: "老客户人均启动次数", name: "7.20", value: 250 },
        { type: "老客户人均启动次数", name: "7.22", value: 770 },
      ];
      const data2 = [
        { type: "整体人均启动次数", name: "6.28", value: 890 },
        { type: "整体人均启动次数", name: "6.30", value: 1840 },
        { type: "整体人均启动次数", name: "7.2", value: 840 },
        { type: "整体人均启动次数", name: "7.4", value: 1140 },
        { type: "整体人均启动次数", name: "7.6", value: 450 },
        { type: "整体人均启动次数", name: "7.8", value: 940 },
        { type: "整体人均启动次数", name: "7.10", value: 1540 },
        { type: "整体人均启动次数", name: "7.12", value: 1640 },
        { type: "整体人均启动次数", name: "7.14", value: 940 },
        { type: "整体人均启动次数", name: "7.16", value: 730 },
        { type: "整体人均启动次数", name: "7.18", value: 1540 },
        { type: "整体人均启动次数", name: "7.20", value: 1290 },
        { type: "整体人均启动次数", name: "7.22", value: 1560 },
      ];

      const data = [...data1, ...data2];
      const chart = new Chart({
        container: id,
        autoFit: true,
        height: 250,
      });
      //设置Y轴的最大最小值
      chart.scale("value", {
        min: 0,
        max: 2000,
      });
      chart.data(data);
      chart.tooltip({
        shared: true,
        showMarkers: false,
      });

      chart.data(data);

      const view1 = chart.createView();
      view1.data(data1);
      if (id == "d3") {
        view1
          .interval()
          .position("name*value")
          .color("type", ["#C185F6", "#5B6FF9", "#657693"])
          .adjust("stack");
      } else {
        view1
          .interval()
          .position("name*value")
          .color("type", ["#5B6FF9", "#44D7B6", "#657693"])
          .adjust("stack");
      }

      const view2 = chart.createView();
      view2.data(data2);

      view2
        .line()
        .position("name*value")
        .shape("dot")
        .color("type", ["#657693"]);
      view2
        .point()
        .position("name*value")
        .shape("circle")
        .color("type", ["#657693"]);
      // chart.interaction("active-region");
      if (id == "d3") {
        chart.legend({
          custom: true,
          items: [
            {
              name: "新客户人均启动次数",
              id: "new",
              marker: { symbol: "square", style: { fill: "#5B6FF9" } },
            },
            {
              name: "老客户人均启动次数",
              id: "old",
              marker: { symbol: "square", style: { fill: "#C185F6" } },
            },
            {
              name: "整体人均启动次数",
              id: "sum",
              marker: { symbol: "square", style: { fill: "#657693" } },
            },
          ],
        });
      } else {
        chart.legend({
          custom: true,
          items: [
            {
              name: "新客户人均启动次数",
              id: "new",
              marker: { symbol: "square", style: { fill: "#5B6FF9" } },
            },
            {
              name: "老客户人均启动次数",
              id: "old",
              marker: { symbol: "square", style: { fill: "#44D7B6" } },
            },
            {
              name: "整体人均启动次数",
              id: "sum",
              marker: { symbol: "square", style: { fill: "#657693" } },
            },
          ],
        });
      }
      chart.render();
    },
  },
};
</script>

<style lang="less">
.visit {
  .my-chard {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .chard-box {
      margin-top: 20px;
      width: 49%;
      height: 480px;
      .fl {
        font-size: 16px;
        display: flex;
        align-items: center;
        b {
          margin-left: 10px;
        }
        img {
          width: 24px;
        }
      }
      .text {
        display: block;
        margin-left: 12px;
        color: #333;
        font-size: 12px;
        line-height: 24px;
        margin-top: 10px;
      }
      //数字区域
      .numDate {
        margin-top: 10px;
        margin-left: 13px;
        .date {
          color: #327eff;
        }
        .num {
          display: flex;
          justify-content: space-between;
          .right {
            margin-right: 60px;
          }
        }
      }
    }
    .first {
      width: 98%;
      height: 680px;
      //公共ul的布局
      ul {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-top: 30px;
        margin-left: 50px;
        li {
          margin-bottom: 30px;
          text-align: left;
          width: 25%;
          box-sizing: border-box;
          p {
            padding-bottom: 10px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(37, 49, 62, 0.85);
            img {
              width: 16px;
              vertical-align: middle;
            }
            &:nth-child(2) {
              font-size: 24px;
              font-weight: bold;
              // color: #327eff;
              span {
                font-size: 14px;
              }
            }
            &:last-child {
              font-size: 12px;
              font-weight: 400;
              color: #7e858c;
              span {
                padding-left: 10px;
              }
            }
          }
          &:nth-child(3n) {
            p {
              border: 0px;
            }
          }
        }
      }

      //顶部栏布局
      .top6 {
        margin-top: -5px;
        .fl {
          float: left;
          font-size: 16px;
          display: flex;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
        }
        .fr {
          float: right;
          color: #999999;
          font-size: 12px;
          p {
            img {
              width: 16px;
              vertical-align: middle;
              //   margin-right: 10px;
            }
          }
          .my-select {
            margin-left: 10px;
          }
        }
      }
      .t1 {
        margin-top: 10px;
        display: flex;
        .t1-1,
        .t1-2,
        .t1-3 {
          box-sizing: border-box;
          margin-left: 10px;
          padding: 20px;
          width: 200px;
          height: 80px;
          background-color: #f5f5f6;
          border-radius: 5px;
          span {
            margin-left: 60px;
            font-size: 24px;
          }
        }
        .t1-1 {
          margin-left: 0;
        }
      }
      .t2 {
        margin-top: 20px;
        width: 100%;
        height: 300px;
        background-color: #f5f7fd;
        display: flex;
        .t2-l {
          height: 100%;
          width: 100px;
          background-color: #688bee;
          display: flex;
          justify-content: center;
          align-items: center;
          .t2-l-img {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #fff;
            img {
              width: 40px;
            }
          }
        }
        .t2-r {
          flex: 1;
        }
      }
      .t3 {
        margin-top: 20px;
        width: 100%;
        height: 150px;
        background-color: #f3f8f1;
        display: flex;
        .t3-l {
          height: 100%;
          width: 100px;
          background-color: #8ac588;
          display: flex;
          justify-content: center;
          align-items: center;
          .t3-l-img {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #fff;
            img {
              width: 40px;
            }
          }
        }
        .t3-r {
          flex: 1;
        }
      }
    }
  }
  //公用区域
 
  .buleBar,
  .greBar,
  .popBar {
    display: inline-block;
    width: 4px;
    height: 13px;
    background-color: #327eff;
    border-radius: 2px;
    margin-right: 10px;
  }
  .greBar {
    background-color: #73deb3;
  }
  .popBar {
    background-color: #c185f6;
  }
  .blueColor {
    color: #327eff;
  }
  .fz43 {
    font-size: 43px;
  }
  .fz12 {
    font-size: 12px;
  }
  .gru {
    color: #19e9aa !important;
  }
  .red {
    color: red !important;
  }
  .bgcBlue {
    background-color: #0091ff !important;
    color: #fff !important;
  }
  .fz16 {
    font-size: 16px;
    font-weight: 600;
  }
  .fz14 {
    font-size: 14px;
  }
}
</style>